// extracted by mini-css-extract-plugin
module.exports = {"overdue":"styles_overdue__36n_B","compactText":"styles_compactText__1-jcs"};